import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import * as APIModels from "../../../../../models";
import { useState } from "react";
import { Form } from "react-bootstrap";
import { AttorneyService } from "../../../../../services/ClientService";

export default function AttorneySyncModal({
    showModal,
    setShowModal,
}: {
    showModal: boolean;
    setShowModal: (value: boolean) => void;
}): JSX.Element {
    const [errorMessage, setErrorMessage] = useState("");
    const [directory, setDirectory] = useState("");

    const handleSubmit = () => {
        setErrorMessage("");
        AttorneyService.updateByDirectory({
            directory: directory,
        }).then(
            (resp) => {
                if (resp.data && resp.successful) {
                    setShowModal(false);
                } else {
                    setErrorMessage("That directory does not exist.");
                }
            },
            (_err) =>
                setErrorMessage("An error occurred contacting the server.")
        );
    };

    return (
        <Modal
            show={showModal}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    Sync Attorney
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form className="form-inline">
                    <Form.Group style={{ marginBottom: "10px" }}>
                        <label>Attorney Directory</label>
                        <input
                            className="form-control"
                            id="SendEmail"
                            type="text"
                            value={directory}
                            onChange={(event) => {
                                setDirectory(event.currentTarget.value);
                            }}
                        />
                    </Form.Group>
                    <div
                        style={{
                            position: "relative",
                            left: "80%",
                            display: "flex",
                        }}
                    >
                        <Form.Group
                            className="form-group"
                            style={{
                                marginRight: "10px",
                            }}
                        >
                            <Button
                                className="btn-primary"
                                onClick={() => {
                                    handleSubmit();
                                }}
                            >
                                Sync
                            </Button>
                        </Form.Group>
                        <Form.Group className="form-group col-sm-6">
                            <Button
                                className="btn-secondary btn"
                                onClick={() => setShowModal(false)}
                            >
                                Cancel
                            </Button>
                        </Form.Group>
                    </div>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <label style={{ float: "left", color: "red" }}>
                    {errorMessage}
                </label>
            </Modal.Footer>
        </Modal>
    );
}
